import * as O from "fp-ts/Option"
import { pipe } from "fp-ts/function"
import type { TenantPlan } from "@/types/api"

/** Page des tarifs du site : plans et contenu de chacun. */
export const PRICING_PAGE_URL = "https://www.qualneo.fr/tarifs"

/**
 * Ouvre la page des tarifs dans un nouvel onglet.
 *
 * @example
 * openPricingPage() // undefined : onglet https://www.qualneo.fr/tarifs ouvert
 */
export function openPricingPage(): void {
  window.open(PRICING_PAGE_URL, "_blank", "noopener,noreferrer")
}

/** Noms des plans, ceux de la page Tarifs. Les codes ne changent pas. */
const PLAN_LABELS: Readonly<Record<TenantPlan, string>> = {
  free: "Gratuit",
  solo: "Solo",
  equipe: "Équipe",
  enterprise: "Entreprise",
}

/**
 * Nom affiché d'un plan, celui de la page Tarifs.
 * Un code inconnu est rendu tel quel.
 *
 * @example
 * planLabel("free") // "Gratuit"
 * planLabel("enterprise") // "Entreprise"
 */
export function planLabel(code: string): string {
  return pipe(
    O.fromNullable(Object.entries(PLAN_LABELS).find(([plan]) => plan === code)),
    O.map(([, label]) => label),
    O.getOrElse(() => code),
  )
}
